import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// ---------------------------------------------------------

import Button from "@components/button"
import Image from "@components/image"

// ---------------------------------------------------------

import {
  image_container,
  person,
  person_description,
  person_meta,
  person_name
} from "./styles.module.scss"

const Person = (props) => {
  const { className, description, image, name, url } = props

  let classes = classNames(person, {
    [className]: className
  })

  const personImage = image
    ? image + "?fit=crop,center&crop=faces&ar=1:1&faceindex=1"
    : "https://amperity.imgix.net/6DAf5hTTVZCbZJn67n2yUC/39ef2699b8be032f5635ea424a613d8c/Author-Amperity_Icon.png"

  return (
    <div className={classes} data-testid="person">
      <Image
        className={image_container}
        alt={name}
        src={personImage}
        sizes="80px"
        width={80}
        height={80}
      />

      <div className={person_meta}>
        {url ? (
          <Button url={url} theme="arrow-horizontal-dark">
            {name}
          </Button>
        ) : (
          <p className={person_name}>{name}</p>
        )}
        <>{description && <p className={person_description}>{description}</p>}</>
      </div>
    </div>
  )
}

Person.propTypes = {
  /**
   * Specifies additional class names
   */
  className: PropTypes.string,
  /**
   * Job title and company.
   */
  description: PropTypes.string,
  /**
   * Image source URL.
   */
  image: PropTypes.string,
  /**
   * Person's full name.
   */
  name: PropTypes.string,
  /**
   * URL to person's people page.
   */
  url: PropTypes.string
}

export default Person
